/* eslint-disable dot-notation */
/* eslint-disable camelcase */
import ApiService, { API_URL } from '@/core/ApiService'
import ApiError from '../ApiError'

export const commonApi = {
  checkBoothTml: async () => {
    try {
      const response = await ApiService.post(API_URL.CHECK_BOOTH_ID, {})
      const responseCode = response.data['response_code']
      if (responseCode === '100') {
        return true
      } else {
        return false
      }
    } catch (error: any) {
      console.error(error.messaage)
      return false
    }
  },
  validChardNo: async (cardNo: string) => {
    const response = await ApiService.post(API_URL.VALID_CARD_NO, { remit_book_id: cardNo })

    // 성공 시
    const responseCode = response.data['response_code']
    const responseMessage = response.data['response_message']

    if (responseCode === '100') {
      return true
    } else if (responseCode === '015') {
      return false
    } else {
      throw new ApiError('901', responseMessage)
    }
  }
}
